/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Checkinflyerformatstory3Inputs */

const en_checkinflyerformatstory3 = /** @type {(inputs: Checkinflyerformatstory3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Story`)
};

const de_checkinflyerformatstory3 = /** @type {(inputs: Checkinflyerformatstory3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Story`)
};

/**
* | output |
* | --- |
* | "Story" |
*
* @param {Checkinflyerformatstory3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const checkinflyerformatstory3 = /** @type {((inputs?: Checkinflyerformatstory3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Checkinflyerformatstory3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_checkinflyerformatstory3(inputs)
	return de_checkinflyerformatstory3(inputs)
});
export { checkinflyerformatstory3 as "checkinFlyerFormatStory" }